export default function Header() {
  const header: HTMLElement | null = document.querySelector("header");

  if (header) {
    const menu: HTMLDivElement | null = header.querySelector(".js-mobile-search-menu-wrapper");
    const menuBtn: HTMLButtonElement | null = header.querySelector(".js-mobile-menu-btn");
    const menuClosedBtn: HTMLSpanElement | null | undefined = menuBtn?.querySelector(".js-mobile-closed-icon");
    const menuOpenBtn: HTMLSpanElement | null | undefined = menuBtn?.querySelector(".js-mobile-open-icon");

    const handleMenuHeight = () => {
      return window.innerHeight - header.offsetHeight;
    };

    const handleOpenSearchMenu = () => {
      if (menuBtn && menuClosedBtn && menuOpenBtn && menu) {
        // update search btn and icons
        menuBtn.classList.add("is-open");
        menuClosedBtn.style.display = "none";
        menuOpenBtn.style.display = "flex";
        menu.style.transform = "translateX(0)";
        menu.style.height = `${handleMenuHeight()}px`;
        document.body.style.overflow = "hidden";
      }
    };

    const handleCloseSearchMenu = () => {
      if (menuBtn && menuClosedBtn && menuOpenBtn && menu) {
        // update search btn and icons
        menuBtn.classList.remove("is-open");
        menuClosedBtn.style.display = "flex";
        menuOpenBtn.style.display = "none";
        menu.style.transform = "translateX(100%)";
        menu.style.height = "";
        document.body.style.overflow = "";
      }
    };

    const toggleSearchMenu = () => {
      if (menuBtn && menuBtn.classList.contains("is-open")) {
        handleCloseSearchMenu();
      } else {
        handleOpenSearchMenu();
      }
    };

    const handleResize = () => {
      if (menuBtn && menuBtn.classList.contains("is-open")) {
        handleCloseSearchMenu();
      }
    };

    if (menuBtn) {
      menuBtn.addEventListener("click", toggleSearchMenu);
    }

    window.addEventListener("resize", handleResize);
  }
}
